import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectGendersState } from '../selectors';

export const getData = createSelector(selectGendersState, (state: State) => state.data);

export const getError = createSelector(selectGendersState, (state: State) => state.error);

export const getLoading = createSelector(selectGendersState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectGendersState, (state: State) => fn(state.data));
